import { Component, ChangeDetectorRef } from '@angular/core'
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community'
import { AgFilterComponent } from 'ag-grid-angular'
import { Option } from '../../app-select/option'

@Component({
  selector: 'app-contains-lookup-filter',
  templateUrl: './lookup-filter/lookup-filter.component.html',
  styleUrls: ['./lookup-filter/lookup-filter.component.scss'],
  standalone: false
})
export class ContainsLookupFilterComponent implements AgFilterComponent {
  private params: IFilterParams

  private _selectAll = true

  public items: Option[] = []

  private _selectedItem: number | string = null

  private _cachedModel: any = null

  public get selectAll(): boolean {
    return this._selectAll
  }
  public set selectAll(value: boolean) {
    this._selectAll = value
    if (value) {
      this._selectedItem = null
      this.params.filterChangedCallback()
    }
  }
  public get selectedItem(): number | string {
    return this._selectedItem
  }
  public set selectedItem(value: number | string) {
    this._selectedItem = value
    this.params.filterChangedCallback()
  }

  constructor(private cdr: ChangeDetectorRef) {}

  agInit(params: IFilterParams): void {
    this.params = params
  }

  setItems(items: Option[]): void {
    this.items = items

    if (this._cachedModel) {
      this.setModel(this._cachedModel)
      this._cachedModel = null
      this.params.filterChangedCallback()
    }

    this.cdr.detectChanges()
  }

  isFilterActive(): boolean {
    return !this.selectAll && !!this.selectedItem
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    const nodeValue =
      this.params
        .getValue(params.node)
        ?.toString()
        .toLowerCase()
        .split(',') ?? []
    return this.selectAll || nodeValue.includes(this.selectedItem?.toString().toLowerCase())
  }

  getModel(): any {
    if (!this.isFilterActive()) return null
    const val = this.selectedItem?.toString()
    if (!isNaN(Number(val))) {
      return { type: 'any', filter: `d:d eq ${val}` }
    }
    return { type: 'any', filter: `d:tolower(d) eq '${val.toLowerCase()}'` }
  }

  setModel(model: any): void {
    if (this.items.length === 0) {
      this._cachedModel = model
      return
    }

    if ((model || {}).filter) {
      const idSplit = model.filter.split('eq')[1].trim()
      const item = this.items.find(x => x.id.toString().toLowerCase() === idSplit.toLowerCase())
      if (item) {
        this._selectAll = false
        this._selectedItem = idSplit
        return
      }
    }

    this._selectAll = true
    this._selectedItem = null
  }
}
